import type { DocumentUploadMode } from "./types";

export type DocumentUploadSurface = "case" | "client";

const INTRO_BY_SURFACE: Record<DocumentUploadSurface, Record<DocumentUploadMode, string>> = {
  case: {
    bundle:
      "Add a named document and attach one or more files (pages/sections). They appear as a single document in the case.",
    separate: "Upload multiple files at once. Each file is saved as its own document row.",
  },
  client: {
    bundle:
      "Enter a document name, select a type, and upload one or more files. Multiple files are saved as one document.",
    separate:
      "Select a type and upload one or more files. Each file is saved as its own document row (name = filename).",
  },
};

export function getDocumentUploadModeIntro(
  surface: DocumentUploadSurface,
  mode: DocumentUploadMode
): string {
  return INTRO_BY_SURFACE[surface][mode];
}

export function formatDocumentUploadResultMessage(args: {
  mode: DocumentUploadMode;
  succeeded: number;
  failed: number;
}): { message: string; status: "success" | "warning" } {
  const { mode, succeeded, failed } = args;
  const status = failed > 0 ? "warning" : "success";

  if (mode === "bundle") {
    return {
      status,
      message:
        failed > 0
          ? "Document uploaded with some files failing. Check the list and retry missing files."
          : "Document has been uploaded successfully.",
    };
  }

  if (failed > 0) {
    return {
      status,
      message: `${succeeded} document${succeeded === 1 ? "" : "s"} uploaded; ${failed} failed.`,
    };
  }

  return {
    status,
    message:
      succeeded === 1
        ? "Document has been uploaded successfully."
        : `${succeeded} documents uploaded successfully.`,
  };
}
